import React, { useEffect } from 'react'
import { Grid, TextField, Typography } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { useTranslation } from 'react-i18next'
import { CardNumberElement, CardCvcElement, CardExpiryElement } from '@stripe/react-stripe-js'
import StripeInput from './stripeInput'
import TextErrorMessage from '../utils/TextErrorMessage'

const StripeElements = () => {
  const { t } = useTranslation()
  const { control, errors, watch, clearErrors, setError } = useFormContext()
  const values = watch()

  useEffect(() => {
    if (values.cardNumber && values.cardNumber.error) {
      setError('cardNumber', { type: 'manual', message: values.cardNumber.error.message })
    } else {
      clearErrors('cardNumber')
    }
  }, [values.cardNumber])

  useEffect(() => {
    if (values.cvc && values.cvc.error) {
      setError('cvc', { type: 'manual', message: values.cvc.error.message })
    } else {
      clearErrors('cvc')
    }
  }, [values.cvc])

  useEffect(() => {
    if (values.expire && values.expire.error) {
      setError('expire', { type: 'manual', message: values.expire.error.message })
    } else {
      clearErrors('expire')
    }
  }, [values.expire])

  return (
    <>
      <Grid item xs={12} lg={11}>
        <Typography variant="subtitle1">{t('booking.paymentInfo.card.number')}</Typography>
      </Grid>
      <Grid item xs={12} lg={11}>
        <Controller
          name="cardNumber"
          control={control}
          rules={{ required: true }}
          as={
            <TextField
              variant="outlined"
              fullWidth
              error={errors.cardNumber}
              InputProps={{
                inputComponent: StripeInput,
                inputProps: { component: CardNumberElement },
              }}
            />
          }
        />
        <ErrorMessage errors={errors} name="cardNumber" render={TextErrorMessage} />
      </Grid>
      <Grid item xs={6} lg={6}>
        <Typography variant="subtitle1">{t('booking.paymentInfo.card.cvc')}</Typography>
        <Controller
          name="cvc"
          control={control}
          rules={{ required: true }}
          as={
            <TextField
              variant="outlined"
              fullWidth
              error={errors.cvc}
              InputProps={{
                inputComponent: StripeInput,
                inputProps: { component: CardCvcElement },
              }}
            />
          }
        />
        <ErrorMessage errors={errors} name="cvc" render={TextErrorMessage} />
      </Grid>
      <Grid item xs={6} lg={6}>
        <Typography variant="subtitle1">{t('booking.paymentInfo.card.expire')}</Typography>
        <Controller
          name="expire"
          control={control}
          rules={{ required: true }}
          as={
            <TextField
              variant="outlined"
              fullWidth
              error={errors.expire}
              InputProps={{
                inputComponent: StripeInput,
                inputProps: { component: CardExpiryElement },
              }}
            />
          }
        />
        <ErrorMessage errors={errors} name="expire" render={TextErrorMessage} />
      </Grid>
    </>
  )
}

export default StripeElements
